import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Layer, Box, Text, Button } from 'grommet';
import PropTypes from 'prop-types';
import Divider from 'granite-admin/core/components/Divider';
import { useToast } from 'granite-admin/core/components/Toast';
import Loader from 'granite-admin/core/components/Loader';
import NoRecordsPlaceholder from 'granite-admin/core/components/NoRecordsPlaceholder';
import taskMasterApi from 'granite-admin/common/gateways/task-master';
import CloseIcon from 'granite-admin/common/assets/CloseIcon';
import { ConfigContext } from '../ConfigProvider';
import TasksSkeletonLoader from './components/TasksSkeletonLoader';
const TaskDetails = ({
  objectId,
  contentTypeName,
  setTaskLayer
}) => {
  const [taskList, setTaskList] = useState(null);
  const {
    successToast,
    errorToast
  } = useToast();
  const config = useContext(ConfigContext);
  const fetchTasks = useCallback(async (objectId, contentTypeName) => {
    try {
      const {
        list
      } = await taskMasterApi.getEntityTasks({
        entity_id: objectId,
        entity_content_type_name: contentTypeName || 'customers_customer',
        page_size: 499
        // is_closed: false,
      });

      const result = list.reduce(function (r, a) {
        r[a.isClosed] = r[a.isClosed] || [];
        r[a.isClosed].push(a);
        return r;
      }, Object.create(null));
      setTaskList(result);
    } catch (e) {
      errorToast('Unable to fetch Tasks!');
    }
  }, [errorToast]);
  useEffect(() => {
    fetchTasks(objectId, contentTypeName);
  }, [objectId, contentTypeName, fetchTasks]);
  const closeTask = useCallback(async pk => {
    try {
      await taskMasterApi.closeTask(pk);
      setTaskList(null);
      fetchTasks(objectId);
      successToast('Task closed successfully!');
    } catch (e) {
      errorToast(e.errors?.title || 'Unable to close task!');
    }
  }, [objectId, errorToast, successToast, fetchTasks]);
  return /*#__PURE__*/React.createElement(Layer, {
    position: "right",
    full: "vertical",
    onClickOutside: setTaskLayer,
    onEsc: setTaskLayer
  }, /*#__PURE__*/React.createElement(Box, {
    elevation: "small",
    width: config?.sliderWidth,
    height: "100%",
    overflow: "auto",
    flex: true
  }, /*#__PURE__*/React.createElement(Box, {
    flex: false
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    align: "center",
    justify: "between",
    pad: "medium"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    weight: "bold"
  }, "Tasks")), /*#__PURE__*/React.createElement(Box, {
    width: "25px",
    height: "25px",
    onClick: setTaskLayer,
    background: "transparent",
    justify: "center",
    align: "center",
    focusIndicator: false,
    style: {
      position: 'absolute',
      left: '-12px',
      top: '0px',
      overflow: 'hidden',
      borderRadius: '50%'
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Divider, {
    color: "brand"
  })), /*#__PURE__*/React.createElement(Box, {
    flex: true,
    basis: "auto",
    height: "0px",
    pad: "medium",
    gap: "medium",
    overflow: {
      vertical: 'auto'
    }
  }, taskList?.true || taskList?.false ? /*#__PURE__*/React.createElement(React.Fragment, null, taskList?.false && /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Active"), taskList && taskList['false']?.map(item => /*#__PURE__*/React.createElement(Box, {
    flex: {
      shrink: 0
    },
    key: item.pk,
    pad: "medium",
    gap: "small",
    elevation: "small",
    round: "xsmall",
    margin: {
      vertical: 'small'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    justify: "between",
    direction: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Name: "), /*#__PURE__*/React.createElement(Text, {
    margin: {
      left: 'xsmall'
    }
  }, " ", item.name, " "))), /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Description: "), /*#__PURE__*/React.createElement(Text, {
    margin: {
      left: 'xsmall'
    }
  }, item.description || 'NA', " ")), /*#__PURE__*/React.createElement(Box, {
    justify: "between",
    direction: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Date: "), /*#__PURE__*/React.createElement(Text, {
    margin: {
      left: 'xsmall'
    }
  }, item.modifiedAt || 'NA', " "))), /*#__PURE__*/React.createElement(Button, {
    alignSelf: "end",
    primary: true,
    label: "Close Task",
    size: "small",
    onClick: () => closeTask(item.pk)
  }))), taskList?.true && taskList?.false && /*#__PURE__*/React.createElement(Divider, {
    color: "brand",
    margin: {
      vertical: 'medium'
    }
  }), taskList?.true && /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Completed"), taskList && taskList['true']?.map(item => /*#__PURE__*/React.createElement(Box, {
    flex: {
      shrink: 0
    },
    key: item.pk,
    pad: "medium",
    gap: "small",
    elevation: "small",
    background: "rgba(173, 171, 171,0.4)",
    margin: {
      vertical: 'small'
    },
    round: "xsmall"
  }, /*#__PURE__*/React.createElement(Box, {
    justify: "between",
    direction: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Name: "), /*#__PURE__*/React.createElement(Text, {
    margin: {
      left: 'xsmall'
    }
  }, " ", item.name, " "))), /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Description: "), /*#__PURE__*/React.createElement(Text, {
    margin: {
      left: 'xsmall'
    }
  }, item.description || 'NA', " ")), /*#__PURE__*/React.createElement(Box, {
    justify: "between",
    direction: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Date: "), /*#__PURE__*/React.createElement(Text, {
    margin: {
      left: 'xsmall'
    }
  }, item.modifiedAt || 'NA', " ")))))) : taskList && Object.keys(taskList)?.length === 0 ?
  /*#__PURE__*/
  // <Box margin={{ top: 'large' }} align="center">
  //   <Text size="large" weight="bold">
  //     No Tasks Found!
  //   </Text>
  // </Box>
  React.createElement(NoRecordsPlaceholder, {
    msg: "No Tasks Found",
    textProps: {
      size: 'large'
    }
  }) : config?.showSkeletonLoader ? /*#__PURE__*/React.createElement(TasksSkeletonLoader, null) : /*#__PURE__*/React.createElement(Box, {
    fill: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, null)))));
};
TaskDetails.propTypes = {
  setTaskLayer: PropTypes.func,
  objectId: PropTypes.string,
  contentTypeName: PropTypes.string
};
export default TaskDetails;